import { render, staticRenderFns } from "./ModalApplyDomainTemplate.vue?vue&type=template&id=08d55564"
import script from "./ModalApplyDomainTemplate.vue?vue&type=script&lang=js"
export * from "./ModalApplyDomainTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports